export default __webpack_public_path__ + "media/zurb/img/services/tools/helio-screenshot1-e6608b7eece8a34bc13971ba63659bd1.png";